export interface CanonicalSector {
  id: string;
  display_name: string;
  aliases: string[];
}

export const CANONICAL_SECTORS: CanonicalSector[] = [
  {
    id: "technology_software",
    display_name: "Technology & Software",
    aliases: ["Technology", "Software", "IT Services", "Tech", "Information Technology", "IT", "Cybersecurity", "Technology & Software"]
  },
  {
    id: "financial_services",
    display_name: "Financial Services",
    aliases: ["Financial", "Finance", "Banking", "Insurance", "Fintech", "Financial Services"]
  },
  {
    id: "manufacturing",
    display_name: "Manufacturing",
    aliases: ["Manufacturing & Industrial", "Industrial", "Automotive", "Aerospace", "Chemicals", "Manufacturing"]
  },
  {
    id: "healthcare_life_sciences",
    display_name: "Healthcare & Life Sciences",
    aliases: ["Healthcare", "Pharma", "Medical", "Biotech", "Health", "Hospital", "Healthcare & Life Sciences"]
  },
  {
    id: "education",
    display_name: "Education",
    aliases: ["Higher Education", "Schools", "Universities", "Academia", "Research", "Education"]
  },
  {
    id: "government_public_sector",
    display_name: "Government & Public Sector",
    aliases: ["Government", "Public Sector", "Defense", "Military", "Municipal", "State", "Government & Public Sector"]
  },
  {
    id: "energy_utilities",
    display_name: "Energy & Utilities",
    aliases: ["Energy", "Utilities", "Oil & Gas", "Power", "Renewables", "Energy & Utilities"]
  },
  {
    id: "telecommunications",
    display_name: "Telecommunications",
    aliases: ["Telecom", "Telecommunications & Media", "Media", "Broadcasting", "ISP", "Telecommunications"]
  },
  {
    id: "ecommerce_retail",
    display_name: "E-Commerce & Retail",
    aliases: ["E-Commerce", "Retail", "Consumer Goods", "Apparel", "Shopping", "E-Commerce & Retail"]
  },
  {
    id: "real_estate_construction",
    display_name: "Real Estate & Construction",
    aliases: ["Real Estate", "Construction", "Property", "Building", "Real Estate & Construction"]
  },
  {
    id: "entertainment_hospitality",
    display_name: "Entertainment & Hospitality",
    aliases: ["Entertainment", "Hospitality", "Travel", "Gaming", "Tourism", "Entertainment & Hospitality"]
  },
  {
    id: "other",
    display_name: "Other",
    aliases: ["Other", "General", "Misc"]
  }
];

export function normalizeSectorName(inputStr?: string | null): string {
  if (!inputStr) return "Other";
  const clean = inputStr.trim().toLowerCase();

  for (const sec of CANONICAL_SECTORS) {
    if (sec.display_name.toLowerCase() === clean || sec.id === clean) {
      return sec.display_name;
    }
  }

  for (const sec of CANONICAL_SECTORS) {
    for (const alias of sec.aliases) {
      if (alias.toLowerCase() === clean || alias.toLowerCase().includes(clean) || clean.includes(alias.toLowerCase())) {
        return sec.display_name;
      }
    }
  }

  return "Other";
}

export function getAllCanonicalDisplayNames(): string[] {
  return CANONICAL_SECTORS.map(s => s.display_name);
}
